import React from 'react';
import moment from "moment";
import { Link } from 'react-router';
import API from "../base/API";
import Auth from "../auth/Auth";
import Storage from "../base/Storage";
import SorTable from "../base/SorTable";
import DeleteButton from "../base/DeleteButton";
import { translate } from "../base/Translation";

export default class ProtocolList extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_protocols: "/protocol/fetch/all?limit_from=:from&limit_max=:to",
			delete_protocol: "/protocol/delete/:protocol"
		});

		this.state = {
			limit_from: 0,
			limit_to: 99999,
			protocols: null,
			tableData: [],
			tableColumns: [
				{ name: "name", display: translate("Názov"), sort: true, width: 40 },
				{ name: "error_db", display: translate("Databáza chýb"), sort: true, width: 24 },
				{ name: "form", display: translate("Dotazník"), sort: true, width: 15 },
				{ name: "date_created", display: translate("Vytvorené"), sort: true, width: 9 },
				{ name: "date_updated", display: translate("Upravené"), sort: true, width: 9 },
				{ name: "options", display: " ", width: 3 }
			]
		};
	}

	convertDataForTable(data) {
		return data.map(function (protocol) {
			let data = {};
			data.id = protocol.id;
			data.name = <Link to={"/protocols/edit/" + protocol.id}>{protocol.name}</Link>;
			data.error_db = protocol.error_db;
			data.form = protocol.form;
			data.date_created = moment(protocol.created.date).format("D.M.Y");
			data.date_updated = moment(protocol.updated.date).format("D.M.Y");
			data.options = (
				<div style={{ textAlign: "right" }}>
					<DeleteButton onClick={this.onDelete.bind({ protocol: protocol.id, currentComponent: this })} permission="ProtocolEdit" />
				</div>
			);
			return data;
		}.bind(this));
	}

	fetchData() {
		this.api.request({
			cache: true,
			route: "get_protocols",
			params: { from: this.state.limit_from, to: this.state.limit_to },
			success: (response) => {
				let tableData = this.convertDataForTable(response);
				this.setState({ protocols: response, tableData });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onDelete(evt) {
		this.currentComponent.api.request({
			route: "delete_protocol",
			params: { "protocol": this.protocol },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	render() {
		return (
			<SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="name" title={translate("Technické protokoly")} right={() => {
				if (Storage.get("allowed_components").indexOf("ProtocolNew") === -1) {
					return "";
				}
				return (
					<Link to="/protocols/add/new" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
				)
			}} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/protocol/ProtocolList.js